import dollaSign from 'jquery';
import select2 from 'select2/dist/js/select2.full';

dollaSign(document).ready(function() {
    select2(dollaSign);

    dollaSign(() => {
        dollaSign('.schedule-input-filter').select2({
            placeholder: 'Kies hier uw filters'
        });
    });

    dollaSign('.schedule-input-filter').on("change", function() {
        this.form.submit();
    });
});
